import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Form = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '410px',
  width: '100%',

  a: {
    marginBottom: '25px',
  },
}));

export const InputsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  width: '100%',
  marginBottom: '10px',

  [theme.breakpoints.down('sm')]: {
    gap: '10px',
    marginBottom: '11px',
  },
}));
